class FaqPageFilter extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.filterSuccess = this.querySelector('.faqs-search-panel__scroll-msg');
    this.filterFail = this.querySelector('.faqs-search-panel__fail-msg');
    this.searchButton = this.querySelector('.faqs-search-panel__svg-wrapper');
    this.noResultsCopy = this.dataset.noResultsCopy;
    this.questions = []
  }

  connectedCallback() {
    this.sections = Array.from(document.querySelectorAll('.section.section-faq'));
    this.contentElement = document.querySelector('.faq-aside-wrapper > div');

    if(!this.contentElement) return;

    this.sections = this.sections.forEach((section) => {
      const questions = section.querySelectorAll('.collapsible-content > button');

      questions.forEach((question) => {
        this.questions.push(question);
      });
    });

    this.input.addEventListener('input', this.onInputChange.bind(this));
    this.input.addEventListener('keypress', this.pressedEnter.bind(this));
    this.searchButton.addEventListener('click', this.onSearchClick.bind(this));
  }

  pressedEnter(event) {
    // when input field is focused and user presses enter, scroll to first question
    if (event.key === 'Enter' && this.input.value !== '') {
      const firstSection = document.querySelector('.section-faq:not(.hidden)');
      if (firstSection) {
        firstSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  onSearchClick() {
    // when search button is clicked, scroll to first question
    const firstSection = document.querySelector('.section-faq:not(.hidden)');
    if (firstSection && this.input.value !== '') {
      firstSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onInputChange(event) {
    const value = event.target.value.toLowerCase();

    this.questions.forEach((question) => {
      const text = question.textContent.toLowerCase();
      const answerElements = question.nextElementSibling.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6, span, td, tr, th');
      let match;
      let contentMatch;

      match = text.includes(value);
      answerElements.forEach((element) => {
        contentMatch = element.textContent.toLowerCase().includes(value);
        if (contentMatch) {
          match = true;
        }
      });

      if (match || contentMatch) {
        question.closest('collapsible-content').classList.remove('hidden');
      } else {
        question.closest('collapsible-content').classList.add('hidden');
      }

      // if all questions are hidden hide entire section
      const section = question.closest('.section-faq');
      if (section) {
        const questions = section.querySelectorAll('collapsible-content');
        const hiddenQuestions = section.querySelectorAll('collapsible-content.hidden');
        if (questions.length === hiddenQuestions.length) {
          section.classList.add('hidden');
        } else {
          section.classList.remove('hidden');
        }
      }
    });

    //if all secitons are hidden append new div with no results message to contentElement
    const sections = document.querySelectorAll('.section-faq');
    const hiddenSections = document.querySelectorAll('.section-faq.hidden');
    if(sections && hiddenSections) {
      if (sections.length == hiddenSections.length) {
        const noResults = document.createElement('div');
        noResults.classList.add('faq-no-results');
        noResults.classList.add('texture-bg-three');
        noResults.textContent = this.noResultsCopy;
        const noResultsEl = document.querySelector('.faq-aside-wrapper .faq-no-results');
        if (!noResultsEl) {
          this.contentElement.appendChild(noResults);
        }
        this.filterFail.classList.remove('hidden');
        this.filterSuccess.classList.add('hidden');
      } else {
        const noResultsEl = document.querySelector('.faq-aside-wrapper .faq-no-results');
        if (noResultsEl) {
          noResultsEl.remove();
        }
        if(this.input.value !== '') {
          this.filterFail.classList.add('hidden');
          this.filterSuccess.classList.remove('hidden');
        } else {
          this.filterFail.classList.add('hidden');
          this.filterSuccess.classList.add('hidden');
        }
      }
    }
  }

}

customElements.define('faq-page-filter', FaqPageFilter);
